
  <ion-chip style="width: fit-content;">
    <ion-note color="primary">Registro RETO : {{version}}</ion-note>
  </ion-chip>

<ion-content>



  <ion-card style="margin: 0 25% ;margin-top : 50px; background-color: moccasin; border-radius: 15px">
    <ion-card-header style=" border-radius: 15px; text-align: center">
      <img src="assets/imagenes/alo-fitosanitarios.png" width="60%">
      <!-- <ion-card-subtitle>Awesome Subtitle</ion-card-subtitle> -->
    </ion-card-header>


    <form [formGroup]="formularioLogin" style=" --background : primary">

      <ion-item style="--background : tranparent ; color: 'dark';">
        <ion-label position="floating">Usuario</ion-label>
        <ion-input formControlName="loginUsuario" [(ngModel)]=variables.usuario (keyup.enter)="formularioLogin.valid ? login():''" type="email">
        </ion-input>
      </ion-item>

      <ion-item style="--background : tranparent">
        <ion-label position="floating">Contraseña</ion-label>
        <ion-input formControlName="passwordUsuario" [(ngModel)]=variables.pwd (keyup.enter)="formularioLogin.valid ? login():''"
          type="password"></ion-input>
      </ion-item>

      <ion-item lines="none" style="--background : tranparent;">
        <ion-label style="text-align : right"> Recordarme</ion-label>
        <ion-checkbox formControlName="recordarusuario" [(ngModel)]="variables.recordarUsuario" slot="end"
          color="primary" (click)="cambiarRecordar()"></ion-checkbox>
      </ion-item>

    </form>

    <div style="padding-top: 15px; padding-bottom: 35px">
      <ion-button style="margin-inline-start: 0px; margin-inline-end: 0px;" type="submit" [disabled]="!formularioLogin.valid" expand="full" color="primary" (click)="login()">login</ion-button>
    </div>

  </ion-card>
</ion-content>
